<template v-if="contextProduct && contextPricing">
  <div class="">
    <template vlif="false">
      <div class="">
        <div class="d-flex justify-content-center">
          <h3 class="mt-3 mb-0">
            Részletező <!-- ToDo: i18n -->
          </h3>
        </div>
        <div class="btn-close float-end" style="margin-top: -24px; cursor: pointer; font-size: 16px;" @click.self="$one?.context.closePlugin"></div>
      </div>
      <hr>
    </template>
    <div class="row text-center">
      <!--table class="qty-table mt-2">
        <thead>
          <tr><th colspan="2">{{ $t("text.discountHead") }}</th></tr>
        </thead>
        <tbody>
          <tr>
            <template v-if="contextStocks && contextPricing">
              <td class="col-9">{{ contextStocks.overallQuantity }} {{ contextUnit }} alatt</td>
              <td class="col-3">{{ $n(contextPricing.discount/100 || 0, "percent") }}</td>
            </template>
          </tr>
          <tr>
            <template v-if="contextStocks">
              <td class="col-9">{{ contextStocks.overallQuantity }} {{ contextUnit }} felett</td>
              <td class="col-3">{{ $n(0, "percent") }}</td>
            </template>
          </tr>
        </tbody>
      </table-->
      <span style="font-weight: 600; font-size: 1.4em;">
        A kiválasztott termék ára <br><div class="btn-close float-end" style="margin-top: -24px; cursor: pointer; font-size: 16px;" @click.self="$one?.context.closePlugin"></div>
        a készlet erejéig érvényes! <br>
        Az azon felüli mennyiséget az alábbi bontásban és árakon tudja a kosárba tenni:
      </span><!-- ToDo: i18n -->
    </div>
    <hr class="mt-2 mb-3">
    <div class="row">
      <table class="qty-table mt-2">
        <thead>
          <tr>
            <th class="col-5">{{ $t("text.discountBreakdown") }}</th>
            <th class="col-2">{{ $t("text.discountPricePerUnit", { unit: contextUnit }) }}</th>
            <th class="col-5">{{ $t("text.discountPriceTotal") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pline, idx) in configurableProducts" :key="idx">
            <template v-if="pline.type === 'ADD'">
              <td>{{ pline.configurableProduct.main.quantity.value }} {{ contextUnit }}</td>
              <td>{{ $n(getProductLinePrice(pline), "currency") }}</td>
              <td>{{ $n(getProductLinePrice(pline) * pline.configurableProduct.main.quantity.value, "currency") }}</td>
            </template>
          </tr>
          <tr v-for="i in (2-getBodyAddedProducts().length)" :key="i"><td colspan="3">&nbsp;</td></tr>
        </tbody>
        <tfoot>
          <tr><th colspan="3">{{ $t("text.totalDiscount") }}</th></tr>
          <tr>
            <td>{{ bodyTotalQuantity }} {{ contextUnit }}</td>
            <td>{{ $n(bodyTotalAvg, "currency") }}</td>
            <td>{{ $n(bodyTotalPrice, "currency") }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="row">
      <div class="d-flex justify-content-center pt-5">
        <AddToCartComponent v-if="contextProduct" :product="contextProduct" :onSubmit="send" v-model:quantity="rawContextQuantity" />
      </div>
    </div>
  </div> 
</template>

<style>
table.qty-table {
  text-align: center;
  width: 90%;
}

table.qty-table, table.qty-table td, table.qty-table th {
  border: 2px solid lightslategray;
  border-collapse: collapse;
  padding: 2px;
  margin: auto;
}
hr {
  border: 2px solid darkgrey !important;
  opacity: 1 !important;
  margin-bottom: 0.5rem !important;
  margin-left: -16px !important;
  width: 380px;
}
</style>

<script>
import { ref } from "vue";
import AddToCartComponent from "./AddToCart.vue";

const _contextQuantity = ref(1);

// eslint-disable-next-line no-unused-vars
function debugLog(...args) {
  console.log("[Sztkm-Vue]", ...args);
  console.log(args["error"]);
}

export default {
  name: "BlockDiscountComponent",
  components: { AddToCartComponent },
  data() {
    return {
      configurableProducts: [],
      contextPricing: null,
      contextProduct: null,
      /*
        Warehouse {
          warehouseId: string
          warehouseLabel: string
          quantity: number
          largestQuantity: number
        }
        StocksForProductsAndWarehouses {
          overallQuantity: number
          selectedWarehouseQuantity: number
          warehouses: Array<Warehouse>
        }
      */
      contextStocks: null,
      contextQuantity: _contextQuantity,
      cartContextQuantity: this.getCartContextQuantity(),
      /** @type {import("../plugins/fetising").Fetising} */
      $fetising: null,
      // /** @type {import('@one-commerce/sdk-core').ShopSdk} */
      // $one: null,
    };
  },
  computed: {
    contextUnit() {
      return this.contextProduct?.measurementUnits.orderUnitDescription.toLowerCase()
    },
    rawContextQuantity() {
      return _contextQuantity;
    },
    bodyTotalPrice() {
      let total = 0;
      for (const pline of this.configurableProducts) {
        if (pline.type != "ADD") continue;
        total += this.getProductLinePrice(pline) * pline.configurableProduct.main.quantity.value;
      }
      return total;
    },
    bodyTotalQuantity() {
      let total = 0;
      for (const pline of this.configurableProducts) {
        if (pline.type != "ADD") continue;
        total += pline.configurableProduct.main.quantity.value;
      }
      return total;
    },
    bodyTotalAvg() {
      return this.bodyTotalQuantity > 0 ? this.bodyTotalPrice/this.bodyTotalQuantity : 0
    }
  },
  methods: {
    getProductLinePrice(pline) {
      let price = parseFloat(pline.configurableProduct.main.priceOverride?.pricePerContentUnit.toFixed(2));
      if (!price) return parseFloat(this.contextPricing.price);
      return price * this.contextProduct.measurementUnits.packingQuantity
    },
    getBodyAddedProducts() {
      const list = []
      for (let product of this.configurableProducts) {
        if (product.type == "ADD") {
          list.push(product);
        }
      }
      return list;
    },
    buildRequestBody() {
      if (!this.contextPricing || !this.contextProduct || !this.contextStocks || isNaN(this.contextQuantity)) return;
      
      // Get added and existing quantity
      let qty = this.contextQuantity + this.cartContextQuantity;

      // Reset payload
      this.configurableProducts.length = 0;

      // Remove existing products from cart
      for (const cartProduct of this.getCartContextProducts()) {
        this.configurableProducts.push({ type: "REMOVE", productLine: cartProduct.productLineId });
      }

      // Add new products to cart
      if (qty > this.contextStocks.selectedWarehousesQuantity) {
        this.configurableProducts.push(
          this.createAddConfigurableProductsIntegrationApiCommand(this.contextProduct, this.contextStocks.selectedWarehousesQuantity, this.contextPricing.price)
        );
        this.configurableProducts.push(
          this.createAddConfigurableProductsIntegrationApiCommand(this.contextProduct, qty-this.contextStocks.selectedWarehousesQuantity, this.contextPricing.catalogPrice)
        );
      } else {
        this.configurableProducts.push(
          this.createAddConfigurableProductsIntegrationApiCommand(this.contextProduct, qty, this.contextPricing.price)
        );
      }

      this.getBodyAddedProducts()
    },
    async send() {
      if (this.configurableProducts) {
        return fetch(process.env.VUE_APP_API_URL + "/api/index.php/add-to-cart-popup", {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            token: this.$one.token,
            customerId: this.$one.account.client.id,

            cartId: this.$one.context.cartId,
            rawOperations: this.configurableProducts
          })
        })
        .then(async (response) => debugLog("ADD2CART-OK", await response.json()))
        .then(() => this.$one.context.closePlugin())
        .catch(async (response) => debugLog("ADD2CART-NOK", await response.json()));
      } else {
        return null;
      }
    },
    getCartContextProducts() {
      let products = [];

      for (const entry of this.$one.cart.currentCart.products) {
        if (entry[1].id !== this.$one.context.productId) continue;
        products.push(entry[1]);
      }
      
      return products;
    },
    getCartContextQuantity() {
      let quantity = 0;

      for (const product of this.getCartContextProducts()) {
        for (const shipment of product.shipments) {
          quantity += shipment.numberOfProducts
        }
      }
      
      return quantity;
    },

    createAddConfigurableProductsIntegrationApiCommand(product, quantity, price) {
      return {
        type: "ADD",
        configurableProduct: {
          main: {
            productId: product.id,
            quantity: {
              type: "ORDER_QUANTITY",
              value: quantity,
            },
            allowQuantityChange: false,
            priceOverride: {
              pricePerContentUnit: price/product.measurementUnits.packingQuantity
            }
          },
          children: []
        }
      }
    },
  },
  mounted() {
    this.$one.catalog.fetchProduct(this.$one.context.productId)
      .then(product => this.contextProduct = product);
    this.$one.catalog.getProductPrice(this.$one.context.productId, false)
      .then(pricing => this.contextPricing = pricing);
    // this.$one.catalog.fetchStocksForProductsAndWarehouses([this.$one.context.productId], this.$one.context.warehouses.map((wh) => wh.id))
    this.$one.catalog.fetchStocksForProductsAndWarehouses([this.$one.context.productId], ["FETFLK"])
      .then(stocks => stocks[this.$one.context.productId])
      .then(stocks => this.contextStocks = stocks);

    /*
    this.$fetising.sztkmcall("sztkm", "getProductQuantity", [ this.$one.context.productId ])
      .then((result) => parseInt(result.quantity))
      .then(quantity => this.contextQuantity = quantity);
    */

    this.contextQuantity = this.$one.context.productAmount;
  },
  watch: {
    "$one.token": function() {
    },
    contextProduct() { this.buildRequestBody(); },
    contextPricing() { this.buildRequestBody(); },
    contextQuantity() { this.buildRequestBody(); },
    contextStocks() { this.buildRequestBody(); },
  },
}

</script>